import { render, staticRenderFns } from "./CollectionChart.vue?vue&type=template&id=1e80e880"
import script from "./CollectionChart.vue?vue&type=script&lang=js"
export * from "./CollectionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports